import { useState, useEffect } from "react";
import { fetchSuccessFactorsByBusinessDomain } from "../api/companyApi";

/**
 * 指定した事業ドメインのKPI使用状況を返すカスタムhook。
 * successFactors の indicators を集約し、使用中の indicatorName の Set を構築する。
 *
 * @param {string} businessDomainId
 * @returns {{ usedKpiNames: Set<string>, loading: boolean }}
 */
export function useKpiUsageStatus(businessDomainId) {
  const [usedKpiNames, setUsedKpiNames] = useState(new Set());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!businessDomainId) return;
    let cancelled = false;
    setLoading(true);
    fetchSuccessFactorsByBusinessDomain(businessDomainId)
      .then((successFactors) => {
        if (cancelled) return;
        const names = new Set();
        (Array.isArray(successFactors) ? successFactors : []).forEach((sf) => {
          (sf.indicators || []).forEach((ind) => {
            if (ind.indicatorName) names.add(ind.indicatorName);
          });
        });
        setUsedKpiNames(names);
      })
      .catch(() => {
        if (!cancelled) setUsedKpiNames(new Set());
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [businessDomainId]);

  return { usedKpiNames, loading };
}
